module.exports = __webpack_public_path__ + "static/img/240.83dab96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/240.jpg
// module id = 6mbc
// module chunks = 0